/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favaccessmgmt.vue?vue&type=template&id=686499f0&scoped=true"
import script from "./favaccessmgmt.vue?vue&type=script&lang=js"
export * from "./favaccessmgmt.vue?vue&type=script&lang=js"
import style0 from "./favaccessmgmt.vue?vue&type=style&index=0&id=686499f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686499f0",
  null
  
)

export default component.exports